import { render, staticRenderFns } from "./comp-nav.vue?vue&type=template&id=555adb16&scoped=true"
import script from "./comp-nav.vue?vue&type=script&lang=js"
export * from "./comp-nav.vue?vue&type=script&lang=js"
import style0 from "./comp-nav.vue?vue&type=style&index=0&id=555adb16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_3rkfgw2sufrnjnd565hqczepoe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555adb16",
  null
  
)

export default component.exports